import {
  Button,
  NewModal,
  Switch
} from '@platform/ui-library';
import { FC, useState } from 'react';
import { useCustomNavigate, useServices } from '@app/hooks';
import { FeatureFlag } from '@app/services';
import { Option } from '@app/types';

const featureFlags: Option<FeatureFlag>[] = [
  {
    label: 'CORE-33213 - Banner Message Node',
    value: FeatureFlag.banner
  },
  {
    label: 'CORE-30729 - D1 Import',
    value: FeatureFlag.d1import
  },
  {
    label: 'DEVDES2-894 About Tab in Settings',
    value: FeatureFlag.inventory
  },
  {
    label: 'CORE-31036 - Rich Text Node',
    value: FeatureFlag.richText
  },
  {
    label: 'CORE-33130 Integrate WalkMe',
    value: FeatureFlag.walkMeWidget
  },
  {
    label: 'DEVDES2-1577 Wizard Config',
    value: FeatureFlag.wizardConfig
  }
];

export const HomeFeaturesPage: FC = () => {
  const navigate = useCustomNavigate();
  const { featureFlagService } = useServices();
  const getEnabledFlags = (): Set<FeatureFlag> => {
    return new Set(featureFlags.map(({ value }) => {
      return value;
    }).filter((flag) => {
      return featureFlagService.isFeatureOn(flag);
    }));
  };
  const [enabledFlags, setEnabledFlags] = useState(getEnabledFlags());

  return (
    <NewModal className="ui-box-small" isOpen>
      <div className="box header">
        <h2>Feature Flags</h2>
      </div>
      <div className="box content">
        {featureFlags.map(({ label, value }) => {
          const checked = enabledFlags.has(value);
          return (
            <Switch
              key={value}
              inputFirst
              label={label}
              checked={checked}
              onChange={() => {
                featureFlagService.setFeature(value, !checked);
                setEnabledFlags(getEnabledFlags());
              }}
            />
          );
        })}
      </div>
      <div className="box footer">
        <Button
          onClick={() => {
            navigate('..');
          }}
          theme="outline"
          type="button"
        >
          Close
        </Button>
      </div>
    </NewModal>
  );
};
